import { useDisconnect, useAppKitAccount } from '@reown/appkit/react'
import { useMetamaskDisconnect } from '../views/home/api/api';
import { useNavigate } from 'react-router-dom';
import { useModalContext } from '../contexts/ModalContext';
import { useToast } from '../hook/usetoast';

export const ActionButtonList = () => {
  const { disconnect } = useDisconnect();
  const { address, isConnected } = useAppKitAccount()
  const userDisconnect = useMetamaskDisconnect()




  const { setIsloadingconnect, isOpenMenu, setIsOpenMenu } = useModalContext()
  const navigate = useNavigate()
  const toast = useToast()

  const disconnectWallet = async () => {
    setIsloadingconnect(true)
    const res = await userDisconnect.mutateAsync({ address: address?.toLowerCase() })
    if (res?.status) {

      disconnect();
      localStorage.removeItem("account")
      localStorage.removeItem('memberId');
      sessionStorage.removeItem('user_JWT')
      localStorage.removeItem("wagmi.connected");
      sessionStorage.removeItem('connectAddress')
      navigate('/')
      toast.error("Wallet disconnected successfully");
      setIsloadingconnect(false)
      setIsOpenMenu(!isOpenMenu)

    }

  };

  return (
    isConnected && (

      <button className="btn btn-primary btnheader h-auto py-1" onClick={disconnectWallet}>  <span className="px-0"> Disconnect</span></button>

    )
  )
}
